// const tagsEnabledCollection = document.querySelectorAll('[data-filter-id]');
// tagsEnabledCollection.forEach((section) => {
//   const tagButtons = section.querySelectorAll('.tag-button');
//   const articles = section.querySelectorAll('.grid-button');

//   // Hide all elements by default
//   articles.forEach((article) => {
//     article.style.display = 'none';
//   });

//   // Display elements with 'all-collections' class by default
//   const allCollectionsElements = section.querySelectorAll('.grid-button.electric-massagers');
//   allCollectionsElements.forEach((element) => {
//     element.style.display = 'block';
//   });

//   tagButtons.forEach((button) => {
//     button.addEventListener('click', function (event) {
//       event.preventDefault();
//       const selectedTag = this.getAttribute('data-tag');
//       articles.forEach((article) => {
//         // Check if the element has the clicked button's data-tag and 'all-collections' class
//         if (article.classList.contains(selectedTag)) {
//           article.style.display = 'block';
//         } else {
//           article.style.display = 'none';
//         }
//       });
//       // Remove the "active" class from all buttons in this section
//       tagButtons.forEach((btn) => {
//         btn.classList.remove('active');
//       });
//       // Toggle the "active" class on the clicked button
//       this.classList.toggle('active');
//     });
//   });
// });

// Get the list and extract list items
var tagList = document.querySelector('.tag-buttons');
var listItems = Array.from(tagList.querySelectorAll('.tag-buttons li'));

// Define the custom order
var customOrder = [
  'Electric Massagers',
  'Wedge Pillows',
  'Kids Pillows',
  'Body Therapy',
  'Cover Replacements',
  'Accessories'
];

// Sort list items based on the custom order and then alphabetically
listItems.sort(function (a, b) {
  var textA = a.textContent.trim();
  var textB = b.textContent.trim();

  // Get the index of the items in the custom order
  var indexA = customOrder.indexOf(textA);
  var indexB = customOrder.indexOf(textB);

  // If items have the same index in the custom order, sort alphabetically
  if (indexA === indexB) {
    return textA.localeCompare(textB);
  }

  // Otherwise, compare the indices for custom sorting
  return indexA - indexB;
});

// Remove existing list items
listItems.forEach(function (li) {
  tagList.removeChild(li);
});

// Append sorted list items back to the list
listItems.forEach(function (li) {
  tagList.appendChild(li);
});
